import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=1149105b&scoped=true"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"
import style0 from "./answerList.vue?vue&type=style&index=0&id=1149105b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149105b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1149105b')) {
      api.createRecord('1149105b', component.options)
    } else {
      api.reload('1149105b', component.options)
    }
    module.hot.accept("./answerList.vue?vue&type=template&id=1149105b&scoped=true", function () {
      api.rerender('1149105b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/exam/answerList.vue"
export default component.exports